import { render, staticRenderFns } from "./DeclaracionesDuenoBeneficiario.vue?vue&type=template&id=554da71a&scoped=true"
import script from "./DeclaracionesDuenoBeneficiario.vue?vue&type=script&lang=js"
export * from "./DeclaracionesDuenoBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./DeclaracionesDuenoBeneficiario.vue?vue&type=style&index=0&id=554da71a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554da71a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554da71a')) {
      api.createRecord('554da71a', component.options)
    } else {
      api.reload('554da71a', component.options)
    }
    module.hot.accept("./DeclaracionesDuenoBeneficiario.vue?vue&type=template&id=554da71a&scoped=true", function () {
      api.rerender('554da71a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/DeclaracionesDuenoBeneficiario.vue"
export default component.exports